<div class="container">

  <header class="page-heading">
    <h1>Term Insurance Calculator</h1>
    <p>Find out how much term life insurance cover you need based on your income, debts and future goals.</p>
  </header>

  <div class="card mb-lg">
    <div class="section-title">Term Insurance Cover Details</div>

    <div class="field-row-2">
      <div class="field-group" [class.has-error]="hasError('annualIncome')">
        <label class="field-label" for="annualIncome">Annual Income</label>
        <div class="input-shell prefix">
          <span class="affix">₹</span>
          <input id="annualIncome" type="number"
            [(ngModel)]="annualIncome"
            [min]="C.annualIncome.min" [max]="C.annualIncome.max" [step]="C.annualIncome.step"
            (ngModelChange)="onFieldChange('annualIncome')"
            (blur)="onFieldBlur('annualIncome')"
            placeholder="e.g. 12,00,000"
            autocomplete="off"/>
        </div>
        @if (hasError('annualIncome')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('annualIncome') }}
          </div>
        }
      </div>

      <div class="field-group" [class.has-error]="hasError('replacementYears')">
        <label class="field-label" for="replacementYears">Income Replacement Period</label>
        <div class="input-shell suffix">
          <input id="replacementYears" type="number"
            [(ngModel)]="replacementYears"
            [min]="C.replacementYears.min" [max]="C.replacementYears.max" step="1"
            (ngModelChange)="onFieldChange('replacementYears')"
            (blur)="onFieldBlur('replacementYears')"
            placeholder="e.g. 15"
            autocomplete="off"/>
          <span class="affix right">Yr</span>
        </div>
        <div class="field-hint">Years your family would need your income replaced &mdash; typically years to retirement or until children are financially independent.</div>
        @if (hasError('replacementYears')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('replacementYears') }}
          </div>
        }
      </div>
    </div>

    <div class="field-row-2">
      <div class="field-group" [class.has-error]="hasError('outstandingLoans')">
        <label class="field-label" for="outstandingLoans">Outstanding Loans</label>
        <div class="input-shell prefix">
          <span class="affix">₹</span>
          <input id="outstandingLoans" type="number"
            [(ngModel)]="outstandingLoans"
            [min]="C.outstandingLoans.min" [max]="C.outstandingLoans.max" [step]="C.outstandingLoans.step"
            (ngModelChange)="onFieldChange('outstandingLoans')"
            (blur)="onFieldBlur('outstandingLoans')"
            placeholder="e.g. 25,00,000"
            autocomplete="off"/>
        </div>
        <div class="field-hint">Home loan, car loan and any other outstanding debt.</div>
        @if (hasError('outstandingLoans')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('outstandingLoans') }}
          </div>
        }
      </div>

      <div class="field-group" [class.has-error]="hasError('futureGoals')">
        <label class="field-label" for="futureGoals">Future Goals</label>
        <div class="input-shell prefix">
          <span class="affix">₹</span>
          <input id="futureGoals" type="number"
            [(ngModel)]="futureGoals"
            [min]="C.futureGoals.min" [max]="C.futureGoals.max" [step]="C.futureGoals.step"
            (ngModelChange)="onFieldChange('futureGoals')"
            (blur)="onFieldBlur('futureGoals')"
            placeholder="e.g. 20,00,000"
            autocomplete="off"/>
        </div>
        <div class="field-hint">Children's education, marriage or other large future expenses.</div>
        @if (hasError('futureGoals')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('futureGoals') }}
          </div>
        }
      </div>
    </div>

    <div class="field-row-2">
      <div class="field-group" [class.has-error]="hasError('existingCover')">
        <label class="field-label" for="existingCover">Existing Life Cover</label>
        <div class="input-shell prefix">
          <span class="affix">₹</span>
          <input id="existingCover" type="number"
            [(ngModel)]="existingCover"
            [min]="C.existingCover.min" [max]="C.existingCover.max" [step]="C.existingCover.step"
            (ngModelChange)="onFieldChange('existingCover')"
            (blur)="onFieldBlur('existingCover')"
            placeholder="e.g. 0"
            autocomplete="off"/>
        </div>
        @if (hasError('existingCover')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('existingCover') }}
          </div>
        }
      </div>

      <div class="field-group" [class.has-error]="hasError('existingSavings')">
        <label class="field-label" for="existingSavings">Existing Savings & Investments</label>
        <div class="input-shell prefix">
          <span class="affix">₹</span>
          <input id="existingSavings" type="number"
            [(ngModel)]="existingSavings"
            [min]="C.existingSavings.min" [max]="C.existingSavings.max" [step]="C.existingSavings.step"
            (ngModelChange)="onFieldChange('existingSavings')"
            (blur)="onFieldBlur('existingSavings')"
            placeholder="e.g. 5,00,000"
            autocomplete="off"/>
        </div>
        @if (hasError('existingSavings')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('existingSavings') }}
          </div>
        }
      </div>
    </div>

    <div class="action-row">
      <button type="button" class="btn btn-primary" (click)="calculate()" [class.btn-disabled]="showFormErrors && !isFormValid">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>
        Calculate
      </button>
      @if (calculated) {
        <button type="button" class="btn btn-secondary" (click)="reset()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
          Reset
        </button>
      }
      @if (showFormErrors && !isFormValid) {
        <span class="form-error-hint">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          Fix the errors above to calculate
        </span>
      }
    </div>
  </div>

  @if (calculated && result) {
    <div class="summary-grid mb-md">
      <div class="summary-card c-blue">
        <div class="sc-icon"></div>
        <div class="sc-label">Recommended Cover</div>
        <div class="sc-value">{{ fmt.currency(result.recommendedCover) }}</div>
        <div class="sc-sub">based on your needs analysis</div>
      </div>
      <div class="summary-card c-green">
        <div class="sc-icon"></div>
        <div class="sc-label">Gross Insurance Need</div>
        <div class="sc-value">{{ fmt.currency(result.grossNeed) }}</div>
        <div class="sc-sub">income replacement + loans + goals</div>
      </div>
      <div class="summary-card c-red">
        <div class="sc-icon"></div>
        <div class="sc-label">Rule-of-thumb Check (15x income)</div>
        <div class="sc-value">{{ fmt.currency(result.ruleOfThumbCover) }}</div>
        <div class="sc-sub">simple benchmark, less precise</div>
      </div>
    </div>

    <div class="card charts-card mb-md">
      <div class="section-title">What Makes Up Your Need</div>
      <div class="chart-panel">
        <div class="chart-canvas-wrap chart-canvas-pie">
          <canvas #breakdownRef></canvas>
        </div>
      </div>
    </div>

    <div class="card mb-md">
      <div class="section-title">Needs Analysis Breakdown</div>
      <div class="tbl-wrap">
        <table>
          <thead>
            <tr>
              <th class="t-left">Component</th>
              <th class="t-balance">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="t-left">Income Replacement ({{ replacementYears }} yrs)</td>
              <td class="t-balance">{{ fmt.currency(result.incomeReplacement) }}</td>
            </tr>
            <tr>
              <td class="t-left">+ Outstanding Loans</td>
              <td class="t-balance">{{ fmt.currency(outstandingLoans) }}</td>
            </tr>
            <tr>
              <td class="t-left">+ Future Goals</td>
              <td class="t-balance">{{ fmt.currency(futureGoals) }}</td>
            </tr>
            <tr>
              <td class="t-left"><strong>= Gross Need</strong></td>
              <td class="t-balance"><strong>{{ fmt.currency(result.grossNeed) }}</strong></td>
            </tr>
            <tr>
              <td class="t-left">&minus; Existing Cover &amp; Savings</td>
              <td class="t-balance">{{ fmt.currency(result.existingCoverAndSavings) }}</td>
            </tr>
            <tr>
              <td class="t-left"><strong>= Recommended Additional Cover</strong></td>
              <td class="t-balance"><strong>{{ fmt.currency(result.recommendedCover) }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  }
</div>

<!-- ══ SEO CONTENT ══════════════════════════════════════════════════════ -->
<section class="container seo-content">
  <div class="card">
    <h2 class="section-title">How Much Term Insurance Cover Do You Need?</h2>
    <p>
      This calculator uses the Human Life Value (needs-based) method: it adds up what your family
      would need to replace your income, pay off outstanding debt, and fund future goals, then
      subtracts what you already have in cover and savings.
    </p>
    <p class="emi-formula">Cover Needed = (Annual Income &times; Replacement Years) + Loans + Future Goals &minus; Existing Cover &minus; Existing Savings</p>
    <p>
      A simpler &mdash; but less precise &mdash; rule of thumb some advisors use is 10&ndash;15
      times your annual income. It's shown alongside the needs-based figure for comparison, but the
      needs-based number better reflects your actual liabilities and goals.
    </p>

    <h2 class="section-title mt-sm">Frequently Asked Questions</h2>
    <div class="faq-item">
      <h3>Why not just rely on the 10&ndash;15x income rule of thumb?</h3>
      <p>
        A flat multiple ignores your actual debts, dependents and goals. Someone with a large home
        loan and young children needs far more cover than someone with the same income but no debt
        and no dependents.
      </p>
    </div>
    <div class="faq-item">
      <h3>Should I include my spouse's income in this calculation?</h3>
      <p>
        No &mdash; this calculator estimates the cover needed to replace your own income and
        obligations. If both spouses earn, each should typically have their own term cover sized to
        their own income and share of family liabilities.
      </p>
    </div>
  </div>
</section>
